import { useEffect, useState } from "react";
import { getBlogDetail, getBlogs } from "../services/api/api";
import { useParams } from "react-router-dom";
import Slider from "react-slick";

const TariffsInTheItSector = () => {
  const settings = {
    slidesToShow: 3.5,
    slidesToScroll: 1,
    draggable: true,
    arrows: false,
    className: "blog_list",
    focusOnSelect: true,
    adaptiveHeight: false,
    prevArrow: (
      <div className="slickbtn slick-prev">
        <svg
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="25.5"
            cy="25.5"
            r="25.5"
            transform="rotate(180 25.5 25.5)"
            fill="url(#paint0_linear_17_4)"
          ></circle>
          <path
            d="M21.414 26L31 26L31 24L21.414 24L25.707 19.707L24.293 18.293L17.586 25L24.293 31.707L25.707 30.293L21.414 26Z"
            fill="white"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear_17_4"
              x1="-0.721698"
              y1="21.675"
              x2="51.0345"
              y2="22.22"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#09C2C1"></stop>
              <stop offset="1" stop-color="#1D85D8"></stop>
            </linearGradient>
          </defs>
        </svg>
      </div>
    ),
    nextArrow: (
      <div className="slickbtn slick-next">
        <svg
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="25.5"
            cy="25.5"
            r="25.5"
            fill="url(#paint0_linear_17_8)"
          ></circle>
          <path
            d="M29.586 25L20 25L20 27L29.586 27L25.293 31.293L26.707 32.707L33.414 26L26.707 19.293L25.293 20.707L29.586 25Z"
            fill="white"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear_17_8"
              x1="-0.721698"
              y1="21.675"
              x2="51.0345"
              y2="22.22"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#09C2C1"></stop>
              <stop offset="1" stop-color="#1D85D8"></stop>
            </linearGradient>
          </defs>
        </svg>
      </div>
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
    ],
  };

  const [blog, setBlog] = useState([]);
  let { blogId } = useParams();
  useEffect(() => {
    getBlogDetail(blogId).then((res) => {
      setBlog(res.data.result);
    });
  }, []);
  console.log(blog);
  return (
    <>
      <div
        className="blog_banner blog-dtl"
        style={{ backgroundImage: "url(./assets/images/new/blog-dtl.png)" }}
      >
        <div className="wrapper">
          <div className="blog-dtl-block">
            <a href="/blogs">
              <img src="/assets/images/new/arrow-blog.svg" alt="arrow" />
            </a>
            {/* this is banner is dynamic */}
            <img src="/assets/images/blogs/blog21.webp" alt="blog" />
          </div>
        </div>
      </div>
      <div className="block-dtl">
        <div className="wrapper">
          <div className="social">
            <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/Facebook.svg"
                alt="facebook"
              />
            </a>
            <a href="https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/Linkedin.svg"
                alt="facebook"
              />
            </a>
            <a href="https://pinterest.com/pin/create/button/?url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img src="/assets/images/site/social/Social.svg" alt="facebook" />
            </a>
            <a href="https://x.com/intent/tweet?url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/twitter.png"
                alt="facebook"
              />
            </a>
            <a href="https://www.instagram.com/?url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/Instagram.svg"
                alt="facebook"
              />
            </a>
          </div>
          <div className="title">
            <div className="title-head">
              <a
                data-aos="zoom-out-up"
                href="javascript:void(0)"
                className="button-container-1 aos-init aos-animate"
              >
                <span className="mas">
              IT Sector
                  {/* this is tag name (dynamic) */}
                </span>
                <span className="mask_btn">
             IT Sector
                  {/* this is tag name (dynamic) */}
                </span>
              </a>

              <span>September 9, 2025</span>
            </div>
            {/* all this content is dynamic  */}
            <div
            // dangerouslySetInnerHTML={{ __html: blog.page_content }}
            >
              <h2>
              Tariffs in the IT Sector: How Trade Policies Impact Technology Businesses in 2025
              </h2>
              <br></br>
              <h3>What Are Tariffs in the IT Industry?</h3>
              <p>In simple terms, tariffs are government-imposed taxes on imports and services. While often associated with goods like steel or textiles, IT companies are directly impacted by tariffs on:</p>
              <ul>
                <li>IT hardware imports (servers, laptops, networking gear)</li>
                <li>Semiconductors & chips (critical for AI, IoT, and cloud computing)</li>
                <li>Software licensing & SaaS platforms</li>
                <li>Cross-border IT services (outsourcing, cloud hosting, and consulting)</li>
                </ul>
              <p>With nations introducing digital service taxes and stricter trade rules, the IT industry must adapt.</p><br></br>
              <h3>Impact of Tariffs on the IT Sector</h3>
              <h4>1. Rising Hardware Costs in IT</h4>
              <p>Most IT hardware—from servers to routers—comes from manufacturing hubs like China, Taiwan, or South Korea.</p>
               <ul>
<li>Higher tariffs = higher procurement costs</li>
<li>Direct impact on IT infrastructure projects and data center setups</li>
</ul>
<p>Example: US-China tariffs increased semiconductor costs, slowing down cloud expansion and AI adoption.</p>
<h4>2. Cloud Services and Data Center Growth Slowdown</h4>
<p>Cloud providers such as AWS, Azure, and Google Cloud depend on imported servers and chips.</p>
<ul>
<li>Tariffs on these imports delay global data center expansion</li>
<li>Businesses may face higher cloud subscription costs</li>
</ul>
<h4>3. Outsourcing & IT Services Face Digital Tariffs</h4>
<p>Many countries are introducing digital service taxes on foreign IT providers.</p>
<ul>
<li>Indian IT service exporters face additional costs when serving US/EU clients</li>
<li>Reduces cost competitiveness in outsourcing</li>
</ul>
<h4>4. Startups & SMEs Bear the Brunt</h4>
<p>Small IT companies and startups rely heavily on imported hardware and affordable SaaS tools.</p>
<ul>
<li>Even a 5–10% tariff hike can disrupt IT project budgets</li>
<li>Impacts innovation and time-to-market for new solutions</li>
</ul>
<h4>5. AI, IoT & Emerging Technologies Take a Hit</h4>
<p>Emerging technologies need high-performance chips like NVIDIA GPUs.</p>
<ul>
<li>Tariffs on semiconductors directly slow down AI training, robotics, and IoT adoption</li>
<li>Could delay advancements in autonomous vehicles, smart cities, and AI research</li>
</ul> <br></br>
<h3>How IT Companies Can Overcome Tariff Challenges</h3>
<p><strong>To stay competitive in a tariff-driven IT world, companies can:</strong></p>
<ul>
<li>Diversify Supply Chains – Source from multiple countries to avoid single-region risk</li>
<li>Nearshore Operations – Set up development and support centers closer to client markets</li>
<li>Promote Local Manufacturing – Invest in "Make in India" or regional chip manufacturing initiatives</li>
<li>Adopt Open-Source & Cloud-Native Tools – Reduce reliance on costly imports and proprietary licenses</li>
<li>Policy Advocacy & Collaboration – Work with trade bodies to influence fair digital trade policies</li>
</ul> <br></br>
<h3>The Future of Tariffs in IT</h3>
<p>In 2025 and beyond, digital tariffs are expected to grow as nations try to tax data flows, SaaS platforms, and cloud usage. IT businesses that innovate, diversify, and localize operations will be best prepared.</p>


            </div>
          </div>
        </div>
      </div>
      <div className="topics-sec">
        <div className="wrapper">
          <div className="topics-head">
            <h3>related topics</h3>
            <a
              data-aos="zoom-out-up"
              href="/blogs"
              className="button-container-1 aos-init aos-animate"
            >
              <span className="mas">View More</span>
              <span className="mask_btn">View More</span>
            </a>
          </div>
          <div className="topics-block">
            <Slider {...settings}>
              {/* href id is dynamic like blog/item.id */}
              <a href={`/best-web-development-company`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="./assets/images/blogs/blog1.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span> Web Development</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        Best Web Development Company: Transforming Your Digital
                        Presence Globally
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <a href={`/custom-mobile-app-development-services`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="./assets/images/blogs/blog16.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span>App Development</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        Elevate Your Business with Custom Mobile App Development
                        Services
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <a href={`/leading-php-company`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="./assets/images/blogs/blog15.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span> Web Development</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        Leading PHP Development Company in India: Unlocking Your
                        Digital Potential
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <a href={`/best-UI-UX-design`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="/assets/images/blogs/blog9.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span>ui & ux</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        We Provide the Best UI/UX Design Solutions for
                        Exceptional User Experiences{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default TariffsInTheItSector;
